/**
 * SessionTimeoutModal — non-dismissable alert shown in the final 2 minutes
 * before automatic logout (UX-15). Displays a live countdown so the agent
 * understands the urgency at a glance.
 */
import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';
import { ShieldAlert } from 'lucide-react';

const fmtMmSs = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const mm = Math.floor(total / 60).toString().padStart(2, '0');
  const ss = (total % 60).toString().padStart(2, '0');
  return `${mm}:${ss}`;
};

const SessionTimeoutModal = ({ open, remainingMs, onStay, onLogout }) => (
  <AlertDialog open={open}>
    <AlertDialogContent data-testid="session-timeout-modal" className="max-w-md">
      <AlertDialogHeader>
        <div className="mx-auto bg-amber-100 text-amber-700 rounded-full p-2.5 w-fit">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <AlertDialogTitle className="text-center font-display">
          Votre session va expirer
        </AlertDialogTitle>
        <AlertDialogDescription className="text-center">
          Par mesure de sécurité, vous serez automatiquement déconnecté dans
          {' '}
          <span
            className="inline-block px-1.5 py-0.5 rounded bg-stone-100 font-mono font-bold text-stone-900"
            data-testid="session-timeout-countdown"
          >
            {fmtMmSs(remainingMs)}
          </span>
          {' '}en raison d&apos;une période d&apos;inactivité prolongée.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="sm:justify-center gap-2">
        <AlertDialogCancel
          onClick={onLogout}
          data-testid="session-timeout-logout-btn"
        >
          Se déconnecter
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onStay}
          className="bg-brand-600 hover:bg-brand-700"
          data-testid="session-timeout-stay-btn"
        >
          Rester connecté
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default SessionTimeoutModal;
